import { render, staticRenderFns } from "./StudentStatisticsTransfer.vue?vue&type=template&id=c1eaba1e&scoped=true&"
import script from "./StudentStatisticsTransfer.vue?vue&type=script&lang=js&"
export * from "./StudentStatisticsTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1eaba1e",
  null
  
)

export default component.exports